import { createFileRoute } from '@tanstack/react-router';
import { Route as service_route } from '@routes/$service';
import { Route as sku_index_route } from '@routes/$service/$productSKU/index';
import { AdPage } from '@src/components/layout/AdPage';
import { ArcadeStoreServiceRowSmall } from '@src/components/store/ArcadeStoreSmallServiceRow';
import { useViewTransition } from '@src/hooks/useViewTransition';

export const Route = createFileRoute('/$service/$productSKU/ad')({
  component: function Component() {
    const service = service_route.useLoaderData();
    const { productSKU } = Route.useParams();
    const _navigate = Route.useNavigate();
    const { slideLeftFullPage } = useViewTransition();

    const navigate = () => {
      _navigate({
        to: sku_index_route.to,
        params: {
          service: service.slug,
          productSKU: productSKU,
        },
        viewTransition: slideLeftFullPage,
      });
    };

    if (!service?.sponsor) {
      navigate();
      return undefined;
    }

    return (
      <AdPage
        sponsor={service.sponsor}
        navigate={navigate}
        service={service.title}
        smallRow={<ArcadeStoreServiceRowSmall service={service} />}
      />
    );
  },
});
